import { render, staticRenderFns } from "./Photovoltaic_Detail.vue?vue&type=template&id=92c021a2&scoped=true&"
import script from "./Photovoltaic_Detail.vue?vue&type=script&lang=js&"
export * from "./Photovoltaic_Detail.vue?vue&type=script&lang=js&"
import style0 from "./Photovoltaic_Detail.vue?vue&type=style&index=0&id=92c021a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c021a2",
  null
  
)

export default component.exports